<script lang="ts" setup>
    import { ref, computed } from 'vue'

    const props = defineProps({
        voraussetzungen: {
            type: String,
            required: true
        },
        allowEdit: {
            type: Boolean,
            required: false,
            default: false
        },
        tooltip: {
            type: String,
            required: false,
            default: () => ''
        },
        language: {
            type: String,
            required: false,
            default: () => 'deutsch'
        }
    })

    const title = computed(() =>
        props.language === 'englisch'
            ? 'Examination prerequisites | Voraussetzung für die Zulassung zur Modulprüfung'
            : 'Voraussetzung für die Zulassung zur Modulprüfung'
    )

    const emit = defineEmits(['voraussetzungenPruefungSaved'])

    let editVoraussetzungen = ref('')

    function handleEditStart() {
        editVoraussetzungen.value = props.voraussetzungen
    }

    function handleEditAbort() {
        editVoraussetzungen.value = ''
    }

    const saveVoraussetzungen = () => {
        emit('voraussetzungenPruefungSaved', editVoraussetzungen.value)
    }
</script>

<template>
    <common-single-edit
        :entry="voraussetzungen"
        edit-key="voraussetzungenPruefung"
        :title="title"
        :tool-tip="tooltip"
        :allow-edit="allowEdit"
        @text-saved="saveVoraussetzungen"
        @edit-aborted="handleEditAbort"
        @edit-started="handleEditStart"
    >
        <template #edit-component>
            <common-my-markup-editor v-model:content="editVoraussetzungen" />
        </template>
        <template #preview-component>
            <!-- eslint-disable-next-line vue/no-v-html -->
            <div v-html="voraussetzungen" />
        </template>
    </common-single-edit>
</template>

<script></script>

<style scoped lang="scss"></style>
